module.exports = __webpack_public_path__ + "img/TOC_completeIcon.48ce0b3a.png";